module.exports = __webpack_public_path__ + "img/eq-light-plate-boots.51c5c06b.png";